var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-offer-tooltip share-offer-addthis",class:{
    '--active': _vm.isVisible,
    '--fromDetails': _vm.origin === 'offer-details'
  }},[_c('div',{staticClass:"share-offer-tooltip-wrapper"},[_c('ShareOffer',{attrs:{"gaTracking":_vm.gaTracking,"origin":_vm.shareOrigin,"offer":_vm.data,"businessName":_vm.data.business.name},on:{"social-network-clicked":function($event){return _vm.$emit('close-tooltip')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }